if (document.getElementsByClassName('js-nestSelect')[0]) {
  nestSelect()

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-nestSelect select:not(.js-nestSelect-nest-3)')
    if (!item) {
      return
    }
    nestSelect(true)
  })
}
function nestSelect(isSetup = false) {
  /* global nestSelectJson */
  const nestSelectList = document.querySelectorAll('.js-nestSelect')

  for (const nestSelect of nestSelectList) {
    const select1 = nestSelect.querySelector('select.js-nestSelect-nest-1')
    const select2 = nestSelect.querySelector('select.js-nestSelect-nest-2')
    const select3 = nestSelect.querySelector('select.js-nestSelect-nest-3')

    const value1 = select1.options[select1.selectedIndex].innerText.trim()
    const value2 = select2.options[select2.selectedIndex].innerText.trim()
    const value3 = select3 && select3.options[0] ? select3.options[select3.selectedIndex].innerText.trim() : '未選択'

    // console.log(value1)
    // console.log(value2)
    // console.log(value3)

    let json1 = null
    let json2 = null

    let isMatch = false // チェックの基準
    let isReset = false // プルダウンをリセットする

    if (!isReset) {
      // ネスト2の内容が正しいか懸賞
      for (const nest1 in nestSelectJson) {
        if (nest1 === value1) {
          // 上の選択肢と同じデータ
          json1 = nest1
          isMatch = true
        }
        for (const nest2 in nestSelectJson[nest1]) {
          if (nest2 === '未選択') {
            continue
          }
          const checkOption = select2.querySelector('option[value="' + nest2 + '"]')
          if ((isMatch && !checkOption) || (!isMatch && checkOption)) {
            // 親に対応した選択肢ではない
            isReset = true
            break
          }
        }
        isMatch = false
      }
    }
    if (isReset) {
      delOption(select2) // オプションを削除する
      setOption(select2, value2, json1)
    }

    if (!isReset && select3) {
      // ネスト3の内容が正しいか懸賞
      for (const nest1 in nestSelectJson) {
        for (const nest2 in nestSelectJson[nest1]) {
          if (nest2 === value2) {
            // 上の選択肢と同じデータ
            json2 = nest2
            isMatch = true
          }

          for (const nest3 of nestSelectJson[nest1][nest2]) {
            if (nest3 === '未選択') {
              continue
            }
            const checkOption = select3.querySelector('option[value="' + nest3 + '"]')
            if ((isMatch && !checkOption) || (!isMatch && checkOption)) {
              // 親に対応した選択肢ではない
              isReset = true
              break
            }
          }
          isMatch = false
        }
      }
    }
    if (isReset && value2 && select3) {
      delOption(select3) // オプションを削除する

      if (value3) {
        setOption(select3, value3, json1, value2)
      }
    }
  }

  if (isSetup) {
    window.selectSetup() // セレクトボックスの初期化
  }

  function delOption(select) {
    if (!select) {
      return
    }
    select.innerHTML = ''
    select.classList.add('is-disable')
    if (select.classList.contains('complete')) {
      // セレクトボックスを独自に変更している場合は解除
      select.classList.remove('complete')
      select.nextElementSibling.parentNode.removeChild(select.nextElementSibling)
      unwrap(select.parentNode) // 親を外す
    }
  }

  function setOption(select, nowSelect = null, json1 = null, json2 = null) {
    let json = null
    let optionCount = 0
    if (json2 !== null) {
      json = nestSelectJson[json1][json2]
      if (json) {
        for (const key of json) {
          ++optionCount
          addOption(select, key, nowSelect)
        }
      }
    } else {
      json = nestSelectJson[json1]
      if (json) {
        for (const key in json) {
          ++optionCount
          addOption(select, key, nowSelect)
        }
      }
    }
    if (optionCount >= 2) {
      // 選択肢があれば有効化
      select.classList.remove('is-disable')
    }

    function addOption(select, key, nowSelect) {
      const option = document.createElement('option')
      option.innerText = key
      option.value = key !== '未選択' ? key : ''

      if (option.value === nowSelect) {
        option.selected = true
      }
      select.appendChild(option) // 最後の子要素として追加
    }
  }

  // 指定した要素を削除して子要素を残す
  // unwrap(document.querySelector('.hoge'))
  function unwrap(target) {
    while (target.firstChild) {
      target.parentNode.insertBefore(target.firstChild, target)
    }
    target.remove()
  }
}
